import { useTranslation } from 'react-i18next'
import { Loader } from '@/components'
import { useInternalHoursBalance } from '@/hooks'
import { HolidayBalanceCard } from './HolidayBalanceCard'

export const InternalHoursBalanceCard = (): JSX.Element => {
  const { t } = useTranslation('internalHours')
  const { data, isLoading } = useInternalHoursBalance()

  if (isLoading) {
    return <Loader />
  }

  if (!data) {
    return <></>
  }

  return <HolidayBalanceCard balance={data} title={t('balance.title')} />
}
